// extracted by mini-css-extract-plugin
export default {"title":"styles_title__fz0c6","icon":"styles_icon__ifK9N","separator":"styles_separator__NFE6r"};